<span (cdkObserveContent)="checkContent()" #contentElement><ng-content></ng-content></span>
<span class="ant-badge-status-dot ant-badge-status-{{dwStatus}}" *ngIf="dwStatus" [ngStyle]="dwStyle"></span>
<span class="ant-badge-status-text" *ngIf="dwStatus">{{ dwText }}</span>
<sup
  *ngIf="showSup"
  [@enterLeave]
  [ngStyle]="dwStyle"
  class="ant-scroll-number"
  [class.ant-badge-count]="!dwDot"
  [class.ant-badge-dot]="dwDot"
  [class.ant-badge-multiple-words]="countArray.length>=2">
  <ng-template
    ngFor
    [ngForOf]="maxNumberArray"
    let-number
    let-i="index">
      <span
        *ngIf="dwCount<=dwOverflowCount"
        class="ant-scroll-number-only"
        [style.transform]="'translateY('+((-countArray[i]*100))+'%)'">
          <ng-template [ngIf]="(!dwDot)&&(countArray[i]!=null)">
            <p *ngFor="let p of countSingleArray" [class.current]="p==countArray[i]">{{ p }}</p>
          </ng-template>
      </span>
  </ng-template>
  <ng-template [ngIf]="dwCount>dwOverflowCount">{{ dwOverflowCount }}+</ng-template>
</sup>